// extracted by mini-css-extract-plugin
export default {"container":"CreateTeam_container__LdhoF","centered":"CreateTeam_centered__nv4As"};